import { t } from '@lingui/core/macro';
import { DialogHeader, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function Header(props) {
    const { isEdit, onClose } = props;
    const title = isEdit
        ? t({ message: 'Edit default eSigning party', comment: 'Title for edit default eSigning party dialog' })
        : t({ message: 'Add default eSigning party', comment: 'Title for add default eSigning party dialog' });
    return (<DialogHeader title={title} icon={<Falcon icon="user"/>} action={<IconButton $round size="small" appearance="ghost" onClick={onClose}>
          <Falcon icon="xmark"/>
        </IconButton>}/>);
}
